import React from "react";
import { connect } from "react-redux";

import "./dashboard.styles.scss";
import ExamPreview from "../../Components/Exam Preview/examPreview.component";
import SideNav from "../../Components/Sidenav/sideNav.component";
import Header from "../../Components/Header/header.component";
import ASSESSMENT_DATA from "../../Redux/Assessment.data";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collections: ASSESSMENT_DATA,
    };
  }

  componentDidMount = async () => {
    const User = await window.sessionStorage.getItem("EmailID");
    if (!User) {
      this.props.history.push("/");
    } else {
      document.title = "Welcome " + User.split('"');
    }
  };

  render() {
    const { collections } = this.state;

    const { Hidden, currentUser } = this.props;
    return (
      <div className="root">
        <Header SideNav />
        <div className="side-nav">{Hidden ? null : <SideNav />}</div>
        {currentUser ? (
          <section className="preview-exam-cards">
            {collections.map(({ id, ...otherCollectionProps }) => (
              <>
                <ExamPreview key={id} {...otherCollectionProps} />
                <hr style={{ color: "black" }} />
              </>
            ))}
          </section>
        ) : (
          ""
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ drawer: { Hidden }, user: { currentUser } }) => ({
  Hidden,
  currentUser,
});
export default connect(mapStateToProps, null)(Dashboard);
